// A stalled/dropped connection doesn't always make fetch() reject on its own —
// without an explicit timeout, a hung request just never resolves, leaving
// whatever loading UI is watching it stuck forever with no error shown.
export const DEFAULT_FETCH_TIMEOUT_MS = 20000;

export function fetchWithTimeout(
  url: string,
  options: RequestInit = {},
  timeoutMs: number = DEFAULT_FETCH_TIMEOUT_MS,
): Promise<Response> {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
  return fetch(url, { ...options, signal: controller.signal }).finally(() =>
    clearTimeout(timeoutId),
  );
}
